import { render, staticRenderFns } from "./TheEndScreen.vue?vue&type=template&id=d70f598a&"
import script from "./TheEndScreen.vue?vue&type=script&lang=js&"
export * from "./TheEndScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports